export function createEmployeeServices(serviceCategories, serviceIDs) {
  if (serviceIDs === undefined) {
    throw new Error('Employer don\'t have "serviceIDs" field!')
  }
  const result = []
  // TODO : to refactor with lodash
  for (let i = 0; i < serviceCategories.length; i++) {
    const SERVICE_CATEGORY = serviceCategories[i]
    const SERVICES_IN_CATEGORY = SERVICE_CATEGORY.services
    let SERVICE_CATEGORY_ACTIVE_SERVICES = 0
    for (let j = 0; j < SERVICES_IN_CATEGORY.length; j++) {
      const SERVICE = SERVICE_CATEGORY.services[j]
      SERVICE.menu = false
      SERVICE.active = false
      if (SERVICE.id in serviceIDs) {
        SERVICE_CATEGORY_ACTIVE_SERVICES++
        SERVICE.active = serviceIDs[SERVICE.id].active
        if (SERVICES_IN_CATEGORY.length === SERVICE_CATEGORY_ACTIVE_SERVICES) {
          SERVICE_CATEGORY.active = true
        }
        if (serviceIDs[SERVICE.id].duration !== null) {
          SERVICE.duration = serviceIDs[SERVICE.id].duration
        }
      }
    }
    result.push(SERVICE_CATEGORY)
  }
  return result
}
